import type {
  ProfessorCreateInputType,
  ProfessorOutputType,
  ProfessorUpdateInputAdminType,
  ProfessorUpdateInputSelfType,
} from '../../../shared/dto';
import { callApi } from './call-api';

export const professoresApi = {
  listar: (_args: void) =>
    callApi<ProfessorOutputType[]>({
      path: '/professores',
    }),

  buscar: (id: string) =>
    callApi<ProfessorOutputType>({
      path: `/professores/${id}`,
    }),

  criar: (body: ProfessorCreateInputType) =>
    callApi<ProfessorOutputType>({
      method: 'POST',
      path: '/professores',
      body,
    }),

  atualizar: ({
    id,
    dados,
  }: {
    id: string;
    dados: ProfessorUpdateInputAdminType | ProfessorUpdateInputSelfType;
  }) =>
    callApi<ProfessorOutputType>({
      method: 'PUT',
      path: `/professores/${id}`,
      body: dados,
    }),
};
